import {useEffect} from "react";
import EventBus from "./event-bus";

const useEventBus = (eventType: string, handler: (...args: any[]) => void) => {
    useEffect(() => {
        EventBus.on(eventType, handler);

        return () => {
            EventBus.removeListener(eventType, handler);
        };
    }, [eventType, handler]);
};

export default useEventBus;
